import { RegisteredIcon } from '@/lib/icons';

export interface NavigationItem {
  icon: RegisteredIcon;
  id: string;
  href: string;
  label: string;
  stroke?: string;
  featureFlag?: string;
}

// Consolidate patient portal nav item ids in once place for better maintenance

export enum NavigationItemIdentifiers {
  Home = 'home',
  Content = 'content',
  Messages = 'messages',
  MyHealth = 'myhealth',
  Agent = 'agent',
  Journey = 'journey',
}

export const navigationItems: NavigationItem[] = [
  {
    id: NavigationItemIdentifiers.Home,
    href: '/home',
    icon: 'feather/home',
    label: 'Home',
    featureFlag: 'enableHomeView',
  },
  {
    id: NavigationItemIdentifiers.Journey,
    href: '/journey',
    icon: 'custom/heart',
    label: 'Journey',
    featureFlag: 'enableJourneyView',
  },
  {
    id: NavigationItemIdentifiers.Content,
    href: '/content',
    icon: 'custom/content',
    label: 'Explore',
  },
];

export const agentNavigationItem: NavigationItem = {
  id: NavigationItemIdentifiers.Agent,
  href: '/agent',
  icon: 'feather/zap',
  label: 'Patient Agent',
};

export interface SelectionState {
  href: string;
  isRoot: boolean;
}

export const getCurrentSectionFromPath = (
  pathname: string
): SelectionState | null => {
  const item = navigationItems.find(({ href }) => pathname.startsWith(href));
  return item ? { href: item.href, isRoot: pathname === item.href } : null;
};
